import { Check } from "lucide-react";
import { Reveal } from "./Reveal";
import { SectionTag } from "./SectionTag";

const standardFeatures = [
  "Carte de fidélité digitale (wallet)",
  "Tamponnage et notifications automatiques",
  "1 point de vente",
];

const proFeatures = [
  "Tout Standard",
  "Page vitrine publique pour votre commerce",
  "Vos boutons fidélité déjà en place",
  "Idéal si vous n'avez pas encore de site",
];

const customFeatures = [
  "Besoins spécifiques ou volume important",
  "Accompagnement dédié",
  "Tarif adapté à votre activité",
];

export function Pricing() {
  return (
    <section id="tarifs" className="bg-cream py-24">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <Reveal className="mx-auto max-w-2xl text-center">
          <SectionTag>Tarifs</SectionTag>
          <h2 className="mt-5 text-4xl font-extrabold tracking-tight text-ink lg:text-5xl">
            Un tarif simple, sans surprise
          </h2>
          <p className="mt-4 text-lg text-ink-soft">
            Créez votre compte en ligne pour démarrer tout de suite, ou parlons de vos besoins spécifiques en
            démo.
          </p>
        </Reveal>

        <div className="mt-14 grid gap-6 lg:grid-cols-3">
          <Reveal delay={0.05}>
            <div className="flex h-full flex-col rounded-2xl border border-line bg-white p-8 shadow-card">
              <p className="text-sm font-bold uppercase tracking-wide text-ink-soft">Standard</p>
              <p className="mt-3 text-3xl font-extrabold text-ink">
                34,99€<span className="text-lg font-semibold text-ink-soft">/mois</span>
              </p>
              <p className="mt-1 text-sm text-ink-soft">Tout ce qu'il faut pour fidéliser</p>
              <ul className="mt-6 flex flex-1 flex-col gap-3">
                {standardFeatures.map((f) => (
                  <li key={f} className="flex items-start gap-2.5 text-sm text-ink-soft">
                    <Check size={16} className="mt-0.5 shrink-0 text-coral" />
                    {f}
                  </li>
                ))}
              </ul>
              <a
                href="/inscription?plan=standard"
                className="mt-8 inline-flex items-center justify-center rounded-full border border-line px-6 py-3 text-sm font-semibold text-ink hover:border-ink"
              >
                Créer mon compte
              </a>
            </div>
          </Reveal>

          <Reveal delay={0.1}>
            <div className="relative flex h-full flex-col rounded-2xl border border-coral/30 bg-white p-8 shadow-soft">
              <span className="absolute -top-3 left-8 rounded-full bg-gradient-brand px-3 py-1 text-xs font-bold uppercase tracking-wide text-white">
                Site web inclus
              </span>
              <p className="text-sm font-bold uppercase tracking-wide text-coral">Pro</p>
              <p className="mt-3 text-3xl font-extrabold text-ink">
                99€<span className="text-lg font-semibold text-ink-soft">/mois</span>
              </p>
              <p className="mt-1 text-sm text-ink-soft">Tout Wara Cards + votre page vitrine</p>
              <ul className="mt-6 flex flex-1 flex-col gap-3">
                {proFeatures.map((f) => (
                  <li key={f} className="flex items-start gap-2.5 text-sm text-ink-soft">
                    <Check size={16} className="mt-0.5 shrink-0 text-coral" />
                    {f}
                  </li>
                ))}
              </ul>
              <a
                href="/inscription?plan=pro"
                className="mt-8 inline-flex items-center justify-center rounded-full bg-ink px-6 py-3 text-sm font-semibold text-white shadow-soft transition-transform hover:scale-[1.03]"
              >
                Créer mon compte
              </a>
            </div>
          </Reveal>

          <Reveal delay={0.15}>
            <div className="flex h-full flex-col rounded-2xl border border-line bg-white p-8 shadow-card">
              <p className="text-sm font-bold uppercase tracking-wide text-ink-soft">Sur mesure</p>
              <p className="mt-3 text-3xl font-extrabold text-ink">Sur devis</p>
              <p className="mt-1 text-sm text-ink-soft">Pour les besoins spécifiques</p>
              <ul className="mt-6 flex flex-1 flex-col gap-3">
                {customFeatures.map((f) => (
                  <li key={f} className="flex items-start gap-2.5 text-sm text-ink-soft">
                    <Check size={16} className="mt-0.5 shrink-0 text-coral" />
                    {f}
                  </li>
                ))}
              </ul>
              <a
                href="#demo"
                className="mt-8 inline-flex items-center justify-center rounded-full border border-line px-6 py-3 text-sm font-semibold text-ink hover:border-ink"
              >
                Réserver une démo
              </a>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
